var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.414,
    height: 54.74,
    viewBox: "27.689 29.835 60.414 54.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.287 29.835h37.218c6.395.024 11.574 5.202 11.598 11.598v31.544a11.583 11.583 0 0 1-3.383 8.19l-.108.099a11.568 11.568 0 0 1-8.082 3.309H39.287a11.568 11.568 0 0 1-8.19-3.407l-.099-.109a11.534 11.534 0 0 1-3.309-8.082V41.433c.02-6.398 5.2-11.58 11.598-11.598ZM54.238 53.3l12.414 8.668a1.863 1.863 0 0 1 .07 3.097l-12.375 8.55a1.844 1.844 0 0 1-1.18.428 1.863 1.863 0 0 1-1.879-1.864V54.82a1.853 1.853 0 0 1 2.95-1.519ZM31.303 42.85h6.883l4.454-9.4h-3.353a8.009 8.009 0 0 0-7.984 7.984v1.416Zm14.602-9.4-4.45 9.4h12.469l4.459-9.386-12.478-.015Zm15.733 0-4.49 9.4h12.145l4.464-9.4h-12.12Zm15.398 0-4.479 9.4H84.49v-1.416a8.024 8.024 0 0 0-7.473-7.97Zm7.473 13.117H31.303v26.41a7.97 7.97 0 0 0 2.286 5.556l.084.079a7.96 7.96 0 0 0 5.614 2.355h37.218a7.97 7.97 0 0 0 5.556-2.262l.078-.088a7.95 7.95 0 0 0 2.35-5.634V46.58Z",
    fill: "#82ceee",
    fillRule: "evenodd",
    "data-name": "video-icon"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/VideoIcon.4ae49446791120d4562b90d0ce9adb8b.svg";
export { ForwardRef as ReactComponent };